import React from 'react';
import { MetricsGrid } from '../components/analytics/MetricsGrid';
import { ChartSection } from '../components/analytics/ChartSection';

export const Analytics = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Analytics</h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Track your team's performance and productivity
        </p>
      </div>

      <MetricsGrid />
      <ChartSection />
    </div>
  );
};

export default Analytics;